<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                    <h6 class="modal-title">{{modalType && modalType == 'edit'?accessTokenData.token_name:$t('Create new access token')}}</h6>
                        <span @click="closeModal" aria-hidden="true"><svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg></span>
                    </div>
                    <div class="modal-body">
                        <div class="common-input-field" style="margin-inline-start: 2%; margin-top: 7px;">
                            <div>
                                <label>{{$t('Access Token Name')}} <span style="font-size: 15px">*</span></label>
                            </div>
                            <div v-if="modalType && modalType == 'edit' && !isEditting('token_name')" v-on:click="enterIntoEditMode('token_name')" class="comm-edit-mode-style">
                                <div>{{accessTokenData["token_name"]}}</div>
                                <svg v-on:click="enterIntoEditMode('token_name')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill edit-icon" viewBox="0 0 16 16">
                                    <title>{{$t('Edit')}}</title>
                                    <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                </svg> 
                            </div>
                            <div v-else-if="modalType && modalType == 'add' || isEditting('token_name')" style="display:flex;align-items: center">
                                <input
                                    v-model="accessTokenData['token_name']"
                                    type="text"
                                    class="rounded text-light comm-input-field-style"
                                    style="padding-inline-end: 4%;"
                                    tabindex="3"
                                    ref="fieldSelectionRef"
                                    autocomplete="off"
                                    :placeholder="$t('Enter access token name')"
                                    :style="modalType && modalType == 'add'?'width:100%':'width: 215px !important'"
                                />
                                <template v-if="modalType && modalType == 'edit'">
                                <svg v-on:click.stop.prevent="editSelectedData('token_name', accessTokenData['token_name'])" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                </svg>
                                <svg v-on:click="editEnabledField = null" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </template>
                            </div>
                        </div>
                        <div v-if="modalType && modalType == 'edit'" class="common-input-field" style="margin-inline-start: 2%; margin-top: 7px;">
                            <div>
                                <label>{{$t('Status')}}</label>
                            </div>
                            <div class="comm-edit-mode-style" style="justify-content: space-between;">
                                <span v-if="accessTokenData.approval_status && accessTokenData.approval_status == 'approved'"
                                    class="text-success"
                                    >Approved</span>
                                <span v-else class="text-danger">Pending</span>
                                <button class="btn btn-outline-primary mr-3" @click='editSelectedData("approval_status",accessTokenData["approval_status"] == "approved"?"pending":"approved")'>{{accessTokenData["approval_status"] == 'pending'?$t('Approve'):$t('Revoke')}}</button>
                            </div>
                        </div>
                        <div class="common-input-field" style="margin-inline-start: 2%; margin-top: 7px;">
                            <div>
                                <label>{{$t('Client Name')}} <span style="font-size: 15px">*</span></label>
                            </div>
                            <div v-if="modalType && modalType == 'edit' && !isEditting('client_name')" v-on:click="enterIntoEditMode('client_name')" class="comm-edit-mode-style">
                                <div>{{accessTokenData["client_name"]}}</div>
                                <svg v-on:click="enterIntoEditMode('client_name')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill edit-icon" viewBox="0 0 16 16">
                                    <title>{{$t('Edit')}}</title>
                                    <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                </svg> 
                            </div>
                            <div v-else-if="modalType && modalType == 'add' || isEditting('client_name')" style="display:flex;align-items: center">
                                <input
                                    v-model="accessTokenData['client_name']"
                                    type="text"
                                    class="rounded text-light comm-input-field-style"
                                    style="padding-inline-end: 4%;"
                                    tabindex="3"
                                    autocomplete="off"
                                    :placeholder="$t('Enter client name')"
                                    :style="modalType && modalType == 'add'?'width:100%':'width: 215px !important'"
                                />
                                <template v-if="modalType && modalType == 'edit'">
                                <svg v-on:click.stop.prevent="editSelectedData('client_name', accessTokenData['client_name'])" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                </svg>
                                <svg v-on:click="editEnabledField = null" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </template>
                            </div>
                        </div>
                        <div class="common-input-field" style="margin-inline-start: 2%; margin-top: 7px;">
                            <div>
                                <label>{{$t('Application Name')}} <span style="font-size: 15px">*</span></label>
                            </div>
                            <div v-if="modalType && modalType == 'edit' && !isEditting('application_name')" v-on:click="enterIntoEditMode('application_name')" class="comm-edit-mode-style">
                                <div>{{accessTokenData["application_name"]}}</div>
                                <svg v-on:click="enterIntoEditMode('application_name')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill edit-icon" viewBox="0 0 16 16">
                                    <title>Edit</title>
                                    <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                </svg> 
                            </div>
                            <div v-else-if="modalType && modalType == 'add' || isEditting('application_name')" style="display:flex;align-items: center">
                                <input
                                    v-model="accessTokenData['application_name']"
                                    type="text"
                                    class="rounded text-light comm-input-field-style"
                                    style="padding-inline-end: 4%;"
                                    tabindex="3"
                                    autocomplete="off"
                                   :placeholder="$t('Enter application name')"
                                    :style="modalType && modalType == 'add'?'width:100%':'width: 215px !important'"
                                />
                                <template v-if="modalType && modalType == 'edit'">
                                <svg v-on:click.stop.prevent="editSelectedData('application_name', accessTokenData['application_name'])" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                </svg>
                                <svg v-on:click="editEnabledField = null" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </template>
                            </div>
                        </div>
                        <div class="common-input-field" style="margin-inline-start: 2%; margin-top: 7px;">
                            <div>
                                <label>{{$t('Privileges')}} <span style="font-size: 15px">*</span></label>
                            </div>
                            <div class="p-0 m-0 active-tag lists-display-ul">
                                <div @click="openPrivilegeSelectionWindow()" class='add-new-lists-styles'>
                                    <div style="margin-inline-end: 5px;position: relative;top: -2px;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                                        </svg>
                                    </div>
                                    <div style="font-size: 14px;">{{$t('Add privileges')}}</div>
                                </div>
                                <div v-if="privilegesArr.length" class="mt-1">
                                    <template v-for="priv in privilegesArr">
                                        <div :key="priv" class="selected-tags-style">
                                            <div>{{priv}}</div>
                                            <div class="remove-tag" v-on:click="removeSelectedPrivilegeFromArr(priv)">
                                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="modalType && modalType == 'add'" class="modal-footer p-0 primary-btn-style">
                        <div>
                            <button class="btn btn-outline-secondary mr-3" @click="closeModal">{{$t('Cancel')}}</button>
                            <button class="btn btn-outline-primary mr-3" @click='createClientAccessTokenButtenAccess'>{{$t('Add')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <privilegeSelectionDialog v-if="openPrivilegeSelection" @selectedPrivileges="selectedPrivileges" :selectedIds="privilegesArr" @close="closePrivilegeSelectionDialog"></privilegeSelectionDialog>
    </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex"
import privilegeSelectionDialog from "./PrivilegeSelectionDialogForAccessToken.vue";
import Utils from "../../components.utils.js";

export default {
  props:["modalType","selectedAccessTokenInfo"],
  data() {
    return {
      show:false,
      time:false,
      editEnabledField:null,
      accessTokenData:{"access_control":{}},
      openPrivilegeSelection: false,
      privilegesArr:["bins-workspace","dam-core-routes","catalogs-workspace","manage-catalogs"]
    };
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.fieldSelectionRef.focus()
            }, 50);
        })
      }
    }
  },
  components:{
    privilegeSelectionDialog
  },
  methods : {
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("settings",["updateClientAccessToken","getAllAccessTokens","deleteClientAccessToken","createClientAccessToken","getClientAccessTokenStatus"]),
    removeSelectedPrivilegeFromArr(priv){
        this.privilegesArr = this.privilegesArr.filter(e => e != priv);
        if(this.modalType && this.modalType == "edit"){
            this.editSelectedData('privileges',this.privilegesArr)
        }
    },
    selectedPrivileges(privileges){
        this.privilegesArr = privileges;
        if(this.modalType && this.modalType == "edit"){
            this.editSelectedData('privileges',this.privilegesArr)
        }
        this.openPrivilegeSelection = false;
    },
    isEditting(keyName) {
      return keyName === this.editEnabledField;
    },
    closeModal(){
        this.$emit("closeAccessTokenModal")
    },

    closePrivilegeSelectionDialog(){
        this.openPrivilegeSelection = false;
    },

    openPrivilegeSelectionWindow(){
        this.openPrivilegeSelection = true;
    },

    createClientAccessTokenButtenAccess(){
        if(!this.accessTokenData["token_name"] || this.accessTokenData["token_name"].length == 0){
            alert("Access token name cannot be empty");
            return false;
        }
        if(!this.accessTokenData["client_name"] || this.accessTokenData["client_name"].length == 0){
            alert("Client name cannot be empty");
            return false;
        }
        if(!this.accessTokenData["application_name"] || this.accessTokenData["application_name"].length == 0){
            alert("Application name cannot be empty");
            return false;
        }
        
        let payload = {};
        this.accessTokenData["access_control"] = {"privileges":this.privilegesArr}
        payload = this.accessTokenData;
        
        this.createClientAccessToken(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if(data.message){
                this.$toast.success(data.message);
            }else{
                this.$toast.success("Added");
            }
            this.closeModal();
          } else {
            if(data.message){
                this.$toast.error(data.message);
            }else{
                this.$toast.error("Failed");
            }
          }
        }).catch(e => {
          this.$toast.error(e);
        })
        
    },
    updateSelectedLicenseNameData(data){
      this.selectedLicenseInfo = data;
    },
    onChnageOfLicenseRequiredValue(option, keyName){
      this.$set(this.requiredLicenseValuesMapper, keyName, option);
    },
    enterIntoEditMode(field){
      this.editEnabledField = field;
    },
    editSelectedData(key, value){
      if(!value || value.length == 0){
        alert(key.replace("_", " ").charAt(0).toUpperCase() + key.replace("_", " ").slice(1) + " field cannot be empty");
        return false;
      }
      let payload = {};
      payload["_id"] = this.selectedAccessTokenInfo._id;
      if(key == 'privileges'){
        payload['access_control']= {'privileges':value};
      }else{
        payload[key] = value;
      }
      this.updateClientAccessToken(payload).then((data) =>{
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if(data.message){
                this.$toast.success(data.message);
            }else{
                this.$toast.success("Updated");
            }
            this.editEnabledField = null;  
          } else {
            if(data.message){
                this.$toast.error(data.message);
            }else{
                this.$toast.error("Failed");
            }
          }
      })
    },
    handleAccessTokenUpdatedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification)Object.assign(this.selectedAccessTokenInfo,notification.message);
      Object.assign(this.accessTokenData,this.selectedAccessTokenInfo);
    },
    registerforWebsocketNotifications(){
          this.addWSEventListener({
            eventname:["ACCESS_TOKEN_UPDATED"],
            callback:this.handleAccessTokenUpdatedNotification,
            parent: "Access Token"});
      },
      unRegisterforWebsocketNotifications(){
          this.removeWSEventListener({
            eventname:["ACCESS_TOKEN_UPDATED"],
            callback:this.handleAccessTokenUpdatedNotification,
            parent: "Access Token"});
      },
  },
  created(){
    if(this.modalType && this.modalType == "edit"){
        this.accessTokenData = this.selectedAccessTokenInfo;
        if(this.accessTokenData.access_control && this.accessTokenData.access_control.privileges)this.privilegesArr = this.accessTokenData.access_control.privileges;
    }
      this.registerforWebsocketNotifications();
  },
  beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
};
</script>

<style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;

.modal-dialog {
    max-width: 50%;
    width: 40%;
    height: 80%;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $secondary-background-color !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      height:100px;
      overflow:auto;
      padding:0px;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 10%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-header .close {
    margin: 0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    align-items: center;
    .modal-title{
      color:$text-color;
    }
}

.primary-btn-style{
    margin-top:1%;
    display: flex;
    justify-content: end;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}
.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $secondary-text-color;
    }
    input{
        flex:1;
    }
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid $active-blue !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.config-desc{
  color: $dull-text-color;
  font-size:12px;
}

svg{
    color: #939393;
}

svg:hover{
    color: #eee !important;
    background: $icon-hover;
    border-radius: 20px;
}

.btn{
  border-radius: 0.25rem !important;
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 35% !important;
    float: inline-start;
    margin-top:8px;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

input:focus,select:focus,textarea:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}


.custom-switch{
    padding-inline-start: 7%;
}

.custom-control-label::before {
    background-color: $primary-background;
}

.custom-control-label::before, .custom-file-label, .custom-select {
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.custom-control-input{
    z-index:999;
}

 /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

    .edit-icon{
      visibility: hidden;
    }

    .comm-edit-mode-style{
      display:flex;
      align-items:center;
    }

    .comm-edit-mode-style:hover{
      .edit-icon{
        visibility: visible;
      }
    }

    .edit-icon{
      margin-inline-start: 5px;
    }

    .edit-icon:hover{
      background: transparent;
      border-radius: 0px;
    }
    .dull-the-text{
      color: $secondary-text-color;
      margin-inline-start:4px;
    }

    .selected-tags-style{
        font-size:12px!important;
        height: 30px!important;
        display: inline-flex!important;
        margin: 2px!important;
        border: 1px solid $tags-border-color!important;
        border-radius: 15px!important;
        min-width: 50px!important;
        padding: 0!important;
        text-align: center;
        width: auto!important;
        padding-inline-start: 10px!important;
        justify-content: center;
        padding-top: 4px!important;
        background: $tags-background-color;
        .remove-tag{
            line-height:18px;
            color: #858585;
        }
    }
.add-new-lists-styles{
  display: inline-flex;
  border-radius: 10px;
  margin: 0px 8px;
  justify-content: start;
  height: 27px;
  color:$add-button-text-color;
  padding: 4px 0px 0px 0px;
  svg{
    fill:$add-button-text-color !important;
  }
}

.add-new-lists-styles:hover{
  color:$add-button-text-color-hover;
  svg{
    fill:$add-button-text-color-hover !important;
  }
}

</style>